export default {
  order: {
    title: "Pedido",
    pickupDate: "Data de recolha",
    pickup: "Local de recolha",
    dropoff: "Local de destino",
    passenger: "Passageiro",
    comment: "Comentário",
    vehicle: "Veículo",
    chauffeur: "Motorista",
    passengersCount: "Passageiros",
    childSeats: "Cadeiras para crianças",
    flightNumber: "Número do voo",
    nameSign: "Placa com nome",
    speaks: "Fala",
    call: "Ligar",
    licensePlate: "Matrícula",
    category: "Categoria",
    status: {
      new: "Confirmação pendente",
      confirmed: "Pedido confirmado",
      on_my_way: "A caminho",
      at_the_location: "Chegou ao local",
      pob: "Passageiro a bordo",
      clear: "Pedido concluído",
      no_show: "Passageiro não compareceu",
      canceled: "Pedido cancelado"
    },
    statusDescriptions: {
      new: "Pedido pendente de confirmação do fornecedor",
      confirmed: "Fornecedor confirmou o pedido, aguardando início",
      on_my_way: "Motorista a caminho do local de recolha",
      at_the_location: "Motorista chegou e aguarda o passageiro",
      pob: "Passageiro embarcou, a caminho do destino",
      clear: "Pedido concluído com sucesso",
      no_show: "O passageiro não compareceu no local de recolha",
      canceled: "Pedido cancelado"
    },
    messages: {
      noChauffeurAssigned: "O seu motorista ainda não foi atribuído",
      detailsWillAppear: "Os detalhes aparecerão aqui após atribuição",
      unknown: "Desconhecido",
      started: "Iniciado",
      awaitingAssignment: "Aguardando atribuição"
    },
    childSeatsTypes: {
      child_01: "Ovo (6 meses)",
      child_02: "Cadeira conversível (0-7 anos)",
      child_03: "Assento elevatório (6-12 anos)"
    },
    distance: "{distance} km",
    review: "Avalie sua viagem",
    review_status: {
      perfect: 'Perfeito',
      good: 'Bom',
      average: 'Regular',
      bad: 'Ruim',
      terrible: 'Terrível'
    }
  },
  common: {
    save: "Guardar",
    cancel: "Cancelar",
    loading: "A carregar...",
    error: "Erro"
  }
}